import {FC, ReactElement} from 'react';
import {styled} from 'styled-components';

import {Button} from '@shared_web/components/core/button';
import {hideModal} from '@shared_web/components/core/modal';

import {Translate} from '@mavismart_frontend/components/translate';
import {BUTTON_THEME2, BUTTON_THEME} from '@mavismart_frontend/lib/constants';

interface GenericConfirmModalProps {
  onConfirm: (e: React.MouseEvent<HTMLElement>) => Promise<void>;
  data?: string | null;
  sendData?: boolean;
  subtitle?: ReactElement;
}

export const GenericConfirmModal: FC<GenericConfirmModalProps> = ({
  onConfirm,
  data,
  sendData,
  subtitle,
}) => {
  return (
    <>
      {subtitle && <Subtitle>{subtitle}</Subtitle>}
      <WrapperButtons>
        <Button themeOverrides={BUTTON_THEME2} expand onClick={hideModal}>
          <Translate value="cancel" />
        </Button>
        <Button
          data-collaborator-email={data}
          themeOverrides={BUTTON_THEME}
          expand
          onClickAsync={onConfirm}
        >
          {sendData ? <Translate value="send" /> : <Translate value="yes" />}
        </Button>
      </WrapperButtons>
    </>
  );
};

GenericConfirmModal.displayName = 'GenericConfirmModal';

const WrapperButtons = styled.div`
  display: flex;
  gap: 10px;
`;

const Subtitle = styled.div`
  margin-bottom: 20px;
  text-align: center;
`;
